import { render, staticRenderFns } from "./CreatedPerformanceTemplate.vue?vue&type=template&id=1b4f89c7&scoped=true"
import script from "./CreatedPerformanceTemplate.vue?vue&type=script&lang=js"
export * from "./CreatedPerformanceTemplate.vue?vue&type=script&lang=js"
import style0 from "./CreatedPerformanceTemplate.vue?vue&type=style&index=0&id=1b4f89c7&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1b4f89c7",
  null
  
)

export default component.exports